// ★ Este arquivo + release-announcement.vue são o ÚNICO mecanismo de
// "novidades"/"what's new" do app. NUNCA crie um segundo modal, banner ou
// componente paralelo pra anunciar release — sempre reuse este, bumpando
// `version` (e o conteúdo abaixo) para a próxima novidade.
//
// Conteúdo do modal de anúncio de release (@modules/global/modal/release-announcement/release-announcement.vue,
// disparado por showReleaseModal() em @router/layouts/main.vue). Cada item de
// `features` vira um slide do carrossel — badge/title/subtitle ficam fixos no
// topo, e a imagem + os cards (`feature.cards`) trocam a cada "Próximo" (ou
// clique na bolinha). Um slide pode ter mais de um card empilhado (ex.:
// "Filtros" + "Ações Rápidas" sobre a mesma imagem) — não precisa ser 1:1
// card:slide.
//
// Para anunciar um NOVO release: só bumpar `version` (qualquer string
// diferente da já persistida em localStorage[RELEASE_MODAL_STORAGE_KEY] já
// basta — showReleaseModal() compara as duas, então reaparece
// automaticamente pra todos) e trocar badge/title/subtitle/features/image
// abaixo. Não precisa mexer no modal nem na wiring em main.vue.
//
// `expiresAt` (opcional, formato 'YYYY-MM-DD', dia civil LOCAL): data-limite
// de exibição. Depois desse dia o anúncio some para qualquer usuário, mesmo quem
// nunca abriu o app durante a janela ativa e mesmo sem ter sido dispensado —
// útil pra aposentar uma novidade que já não faz mais sentido mostrar sem
// precisar apagar `version`/conteúdo (histórico fica preservado). O dia de
// `expiresAt` em si ainda conta como válido; só o dia seguinte esconde (ver
// isReleaseExpired em release-modal-storage.js). Campo opcional e
// retrocompatível: se omitido, o anúncio nunca expira por data (comportamento
// de sempre).
export const RELEASE_MODAL_STORAGE_KEY = 'release-modal-seen-version'

export const CURRENT_RELEASE = {
  version: '2026.07-nav2026',
  // Anúncio aposentado (stale) — data-limite fixada em sexta-feira, para não
  // seguir reaparecendo indefinidamente para quem ainda não abriu o app.
  // Ainda aparece normalmente até o fim de 11/09/2026; a partir de
  // 12/09/2026 some para quem não viu. Conteúdo abaixo preservado apenas como
  // referência histórica; não reative removendo este campo, bumpe `version`
  // pra um novo anúncio.
  expiresAt: '2026-09-11',
  badge: 'Nova Release',
  title: 'Nova Experiência de Gestão',
  subtitle:
    'Otimizamos o fluxo de trabalho para maior produtividade e foco analítico.',
  actionLabel: 'Entendido',
  // Imagem padrão (usada por qualquer feature abaixo que não declarar a sua
  // própria via `feature.image`).
  image:
    'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/assets/images/releases/relase-modal-design-2026.png',
  // Cada item vira um slide do carrossel (imagem + 1 ou mais cards).
  features: [
    {
      image:
        'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/assets/images/releases/filtros_release_2026_5.gif',
      cards: [
        {
          title: 'Filtros',
          icon: 'filter-new-ux',
          description:
            'Os filtros agora ficam fixos no topo da página, liberando espaço vertical para o que realmente importa e garantindo acesso rápido sem precisar rolar a tela.',
        },
        {
          title: 'Ações Rápidas',
          icon: 'task-square',
          description:
            'Os botões de ação também foram movidos para o topo, sempre visíveis e a um clique de distância — sem precisar procurar ou rolar a página.',
        },
      ],
    },
    {
      image:
        'https://aawz-public-tenancies.s3.us-east-2.amazonaws.com/assets/images/releases/cliente_view_release_2026.gif',
      cards: [
        {
          title: 'Navegação por Escopo',
          icon: 'route-square',
          description:
            'Ao selecionar um cliente, a navegação inteligente adapta a interface para exibir apenas os módulos e informações relevantes para aquele contexto.',
        },
        {
          title: 'Módulos no Contexto do Cliente',
          icon: 'user-tag',
          description: 'Cada módulo passa a operar escopado ao cliente selecionado.',
        },
      ],
    },
  ],
}
